import { Reveal } from "@/components/motion/Reveal";

const values = [
  ["Integridad", "Actuamos con transparencia y ética profesional en cada proyecto."],
  ["Compromiso", "Nos apropiamos de los objetivos de cada organización."],
  ["Excelencia", "Buscamos la calidad técnica y humana en cada entregable."],
  ["Confidencialidad", "Protegemos la información de nuestros clientes."],
  ["Innovación", "Aplicamos metodologías modernas y adaptativas."],
  ["Orientación a resultados", "Trabajamos para generar valor tangible y medible."],
  ["Cercanía", "Escuchamos, acompañamos y traducimos requisitos técnicos."],
  ["Mejora continua", "Impulsamos ciclos PHVA sostenibles en el tiempo."],
];

const ABOUT_IMG = "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHxleGVjdXRpdmUlMjB0ZWFtJTIwbWVldGluZ3xlbnwwfHx8fDE3ODQ3NTQyNTJ8MA&ixlib=rb-4.1.0&q=85";

export default function About() {
  return (
    <section id="nosotros" className="relative py-24 md:py-36 border-t border-[#1A1A1A]/10" data-testid="about-section">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <Reveal>
          <div className="eyebrow mb-6">— 01 · Nosotros</div>
          <h2 className="display-2 max-w-4xl">Conozca <em className="italic font-serif text-[#1B3B2B]">KB Consultoría</em></h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-12 gap-6 md:gap-10">
          {/* Left: image */}
          <div className="col-span-12 md:col-span-5">
            <Reveal>
              <div className="relative aspect-[4/5] overflow-hidden">
                <img src={ABOUT_IMG} alt="Equipo ejecutivo revisando indicadores" className="w-full h-full object-cover duotone" loading="lazy" />
              </div>
              <p className="mt-3 text-[11px] tracking-[0.22em] uppercase text-[#4A4A4A]">Fig. 01 · Equipo directivo</p>
            </Reveal>
          </div>

          {/* Right: copy */}
          <div className="col-span-12 md:col-span-7 md:pl-6">
            <Reveal delay={0.15}>
              <p className="font-serif text-2xl md:text-3xl leading-[1.25] text-[#1A1A1A]">
                Acompañamos a organizaciones en la implementación y fortalecimiento de sistemas de gestión con enfoque práctico, sostenible y orientado a resultados.
              </p>
              <p className="mt-6 text-[#4A4A4A] max-w-2xl leading-relaxed">
                Combinamos experiencia técnica, cercanía con el cliente y metodologías probadas para transformar requisitos normativos en herramientas de gestión útiles y funcionales para cada realidad organizacional.
              </p>
            </Reveal>

            <div className="mt-12 grid grid-cols-2 gap-6">
              <Reveal delay={0.2}>
                <div className="border-t border-[#1A1A1A]/15 pt-4">
                  <div className="eyebrow">Nuestra misión</div>
                  <p className="mt-3 text-sm leading-relaxed text-[#1A1A1A]">
                    Brindar soluciones de consultoría que permitan a las organizaciones fortalecer sus procesos, mejorar su desempeño y alcanzar sus objetivos estratégicos mediante metodologías prácticas, personalizadas y sostenibles.
                  </p>
                </div>
              </Reveal>
              <Reveal delay={0.28}>
                <div className="border-t border-[#1A1A1A]/15 pt-4">
                  <div className="eyebrow">Nuestra visión</div>
                  <p className="mt-3 text-sm leading-relaxed text-[#1A1A1A]">
                    Ser una consultora reconocida por su excelencia, cercanía y capacidad de generar mejoras sostenibles y resultados medibles para sus clientes.
                  </p>
                </div>
              </Reveal>
            </div>
          </div>
        </div>

        {/* Values grid */}
        <div className="mt-24">
          <Reveal>
            <div className="eyebrow mb-6">Nuestros valores</div>
          </Reveal>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border-t border-l border-[#1A1A1A]/15">
            {values.map(([title, desc], i) => (
              <Reveal key={title} delay={i * 0.05}>
                <div className="border-r border-b border-[#1A1A1A]/15 p-6 md:p-8 h-full hover:bg-[#EFEBE2] transition-colors" data-testid={`value-${i}`}>
                  <div className="chapter-num text-[2.25rem]">{String(i + 1).padStart(2, "0")}</div>
                  <div className="mt-4 font-serif text-2xl leading-tight">{title}</div>
                  <p className="mt-2 text-sm text-[#4A4A4A] leading-relaxed">{desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
